import React from 'react';
import { LikeIcon } from 'icons';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { useAppDispatch } from 'store';

import { IOffer } from '../models';
import { openModal } from '../store';

interface IProps {
  offer?: IOffer;
}

const RecommendedCentersCard: React.FC<IProps> = ({ offer }) => {
  const t = useTranslations();
  const dispatch = useAppDispatch();

  return (
    <div
      onClick={() => dispatch(openModal(offer))}
      className="block cursor-pointer rounded-lg border border-gray-100 hover:bg-gray-50"
    >
      <div className="h-19 flex gap-2">
        <div className="py-2 pl-2">
          {offer?.learning_center?.cover_image ? (
            <div className="w-22.5 h-15 relative">
              <Image
                fill
                title="Kursni tasvirlovchi rasm"
                className="rounded-md object-cover"
                alt={offer?.learning_center?.name || 'Course Image'}
                src={offer?.learning_center?.cover_image || '/images/no-image.webp'}
              />
            </div>
          ) : (
            <div className="h-15 w-22.5 flex items-center justify-center rounded-xl bg-gray-50">
              <Image
                alt={offer?.learning_center?.name || 'Course Image'}
                src="/images/default-no-image.webp"
                height={30}
                width={30}
                title="Kursni tasvirlovchi rasm"
              />
            </div>
          )}
        </div>
        <div className="relative flex h-full w-full flex-1 flex-col justify-between">
          {offer?.discount ? (
            <div className="absolute flex items-center gap-1 right-0 top-0 rounded-bl-xl border border-l-red-500 border-transparent border-b-red-500 px-2 py-0.5 text-xs text-red-500">
              -{offer?.discount}% <span className='hidden sm:block'>{t('chegirma')}</span>
            </div>
          ) : null}
          {offer?.learning_center?.is_recommended ? (
            <div className="absolute bottom-0 left-0 flex items-center gap-1 rounded-t-[0.6rem] bg-orange-500 px-2 py-0.5 text-[0.6rem] text-white">
              <LikeIcon /> {t('akam_tavsiya')}
            </div>
          ) : null}

          <div className="flex flex-col pt-2">
            <span className="line-clamp-2 text-sm font-semibold max-w-3/4">{offer?.learning_center?.name}</span>
            <span className="line-clamp-1 text-xs text-gray-400">{offer?.subject?.name}</span>
            {/* KERAK BO"LADI <div className="flex items-center gap-1 text-xs">
              <EyeIcon /> 1212
            </div> */}
          </div>
          <div className="flex items-end justify-end space-x-1 pb-2 pr-2 text-green-500">
            <span className="font-semibold">{offer?.price?.toLocaleString('ru')}</span>{' '}
            <span className="font-xs font-light">so’m</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecommendedCentersCard;
